module.exports = __webpack_public_path__ + "img/derby_900.d487503c.png";